<template>
  <div class="font-size-14">
    <yxt-row class="bg-white">
      <yxt-col>
        <div>
          <yxt-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
              <yxt-form-item class="color-gray-9" prop="forceSubmitTime" :label="$t('pc_biz_ote_lbl_examlimit')">
                <yxt-checkbox v-model="isForceSubmitCtrl" class="">{{ $t('pc_biz_ote_lbl_submittime') }}</yxt-checkbox>
                <span class="ml10" v-if="isForceSubmitCtrl">
                  <yxt-date-picker
                    v-model="ruleForm.forceSubmitTime"
                    type="datetime"
                    :placeholder="$t('pc_biz_ote_tip_submittime')"
                    format="yyyy-MM-dd HH:mm"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    style="width:440px"
                   >
                  </yxt-date-picker>
                </span>
                <yxt-tooltip effect="dark" :content="$t('pc_biz_ote_tip_submittimetip')" placement="top">
                  <span class="ml8 v-mid color-gray-9"><yxt-svg class="yxtbiz-exam-arrange__tip-icon" width="16px" height="16px" icon-class="info-cirlce-o" /></span>
                </yxt-tooltip>
              </yxt-form-item>
              <yxt-form-item class="color-gray-9" prop="usedTimesLenMin" :label="''">
                <yxt-checkbox v-model="isUsedTimesCtrl" class="">{{ $t('pc_biz_ote_lbl_examtimelength') }}</yxt-checkbox>
                <span v-if="isUsedTimesCtrl">
                  <span class="ml10">
                    <yxt-input v-model="ruleForm.usedTimesLenMin" maxlength="3" v-enter-number style="width:96px;"></yxt-input>
                  </span>（{{ $t('pc_biz_ote_lbl_minites') }}）<yxt-tooltip effect="dark" :content="$t('pc_biz_ote_tip_examtimeendsubmit')" placement="top">
                    <span class="ml8 v-mid color-gray-9"><yxt-svg class="yxtbiz-exam-arrange__tip-icon" width="16px" height="16px" icon-class="info-cirlce-o" /></span>
                  </yxt-tooltip>
                </span>
              </yxt-form-item>
              <yxt-form-item class="color-gray-9" prop="repeatTimes">
                <yxt-checkbox v-model="isRepeated" class="" :disabled="status !== 0">{{ $t('pc_biz_ote_lbl_allowrepeat') }}</yxt-checkbox>
                <span v-if="isRepeated">
                  <yxt-input :disabled="status !== 0" maxlength="2" v-model="ruleForm.repeatTimes" class="mh8" v-enter-number  style="width:96px;"></yxt-input>{{ $t('pc_biz_ote_lbl_time') }}
                  <yxt-tooltip  effect="dark" :content="$t('pc_biz_ote_tip_allowrepeattip')" placement="top">
                    <span class="ml8 v-mid color-gray-6"><yxt-svg class="yxtbiz-exam-arrange__tip-icon-t2" width="16px" height="16px" icon-class="info-cirlce-o" /></span>
                  </yxt-tooltip>
                </span>
              </yxt-form-item>
              <yxt-form-item class="color-gray-9">
                  <!-- 已有学员参与不支持问答题允许考生上传附件 -->
                <yxt-checkbox v-model="isAllowUpload" class="" :disabled="status !== 0">{{ $t('pc_biz_ote_lbl_allowuploadattach') }}
                <yxt-tooltip  effect="dark" :content="$t('pc_biz_ote_lbl_allowuploadattach')" placement="top">
                  <span class="ml8 v-mid color-gray-9"><yxt-svg class="yxtbiz-exam-arrange__tip-icon" width="16px" height="16px" icon-class="info-cirlce-o" /></span>
                </yxt-tooltip></yxt-checkbox>
              </yxt-form-item>
              <!-- 批阅限制 -->
              <yxt-form-item class="color-gray-9" :label="$t('pc_biz_ote_lbl_marklimit')">
                <yxt-checkbox v-model="isAutoMarkFillin" class="">{{ $t('pc_biz_ote_lbl_fillinautomark') }}
                </yxt-checkbox>
              </yxt-form-item>
              <yxt-form-item class="color-gray-9">
                <yxt-checkbox v-model="isAutoMarkAnswer" class="">{{ $t('pc_biz_ote_lbl_answerautomark') }}
                </yxt-checkbox>
              </yxt-form-item>
              <yxt-form-item class="color-gray-9">
                <yxt-checkbox v-model="isAnonyMark" class="" :disabled="status !== 0">{{ $t('pc_biz_ote_lbl_anymousmark') }}
                <yxt-tooltip  effect="dark" :content="$t('pc_biz_ote_lbl_anymousmark')" placement="top">
                  <span class="ml8 v-mid color-gray-9"><yxt-svg class="yxtbiz-exam-arrange__tip-icon" width="16px" height="16px" icon-class="info-cirlce-o" /></span>
                </yxt-tooltip></yxt-checkbox>
              </yxt-form-item>
              <yxt-form-item class="color-gray-9">
                <yxt-checkbox v-model="isNoAnswerNoMark" class="" :disabled="status !== 0">{{ $t('pc_biz_ote_lbl_notautomarkofnull') }}
                <yxt-tooltip  effect="dark" :content="$t('pc_biz_ote_lbl_automarktip')" placement="top">
                  <span class="ml8 v-mid color-gray-9"><yxt-svg class="yxtbiz-exam-arrange__tip-icon" width="16px" height="16px" icon-class="info-cirlce-o" /></span>
                </yxt-tooltip></yxt-checkbox>
              </yxt-form-item>
              <!-- 答卷设置 -->
              <yxt-form-item class="color-gray-9" :label="$t('pc_biz_ote_lbl_answersetting')">
                <yxt-checkbox v-model="isAllowViewResultDetail" class="">{{ $t('pc_biz_ote_lbl_allowviewanswerdetail') }}</yxt-checkbox>
                <div class="ml24">
                  <div>
                    <yxt-checkbox v-model="isAllowViewResultDetailErrorQues" v-if="isAllowViewResultDetail" class=" width-percent-100">{{ $t('pc_biz_ote_lbl_allowviewanswerwrong') }}</yxt-checkbox>
                    <yxt-checkbox v-model="isAllowViewResultDetailAnswer" v-if="isAllowViewResultDetail" class=" width-percent-100">{{ $t('pc_biz_ote_lbl_allowviewanswer') }}</yxt-checkbox>
                    <yxt-checkbox v-model="isAllowViewResultDetailExplain" v-if="isAllowViewResultDetail" class=" width-percent-100">{{ $t('pc_biz_ote_lbl_allowviewanswerdesc') }}</yxt-checkbox>
                  </div>
                  <div>
                    <yxt-checkbox v-model="isAllowViewResultDetailTime" v-if="isAllowViewResultDetail" class="">{{ $t('pc_biz_ote_lbl_allowviewtimelimit') }}</yxt-checkbox>
                    <div class="ml24">
                      <yxt-date-picker
                        style="width:440px"
                        v-if="isAllowViewResultDetailTime"
                        v-model="ViewResultDetailTime"
                        type="datetimerange"
                        :range-separator="$t('pc_biz_ote_lbl_to')"
                        :start-placeholder="$t('pc_biz_ote_lbl_starttime')"
                        :end-placeholder="$t('pc_biz_ote_lbl_endtime')"
                        format="yyyy-MM-dd HH:mm"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        class="">
                      </yxt-date-picker>
                    </div>
                  </div>
                </div>
              </yxt-form-item>
              <!-- 防作弊 -->
              <yxt-form-item class="color-gray-9">
                <yxt-checkbox v-model="isRandomSort" class="" :disabled="status !== 0">{{ $t('pc_biz_ote_lbl_quesnoorder') }}</yxt-checkbox>
              </yxt-form-item>
              <yxt-form-item class="color-gray-9">
                <yxt-checkbox v-model="isRandomItemSort" class="" :disabled="status !== 0">{{ $t('pc_biz_ote_lbl_quesitemnoorder') }}</yxt-checkbox>
              </yxt-form-item>
              <yxt-form-item class="color-gray-9">
                <yxt-checkbox v-model="isOnlyPc" class="" :disabled="status !== 0">{{ $t('pc_biz_ote_lbl_allowexaminpc') }}</yxt-checkbox>
              </yxt-form-item>
              <yxt-form-item class="color-gray-9">
                <yxt-checkbox v-model="isOnlyMobile" class="" :disabled="status !== 0">{{ $t('pc_biz_ote_lbl_allowexaminh5') }}
                <yxt-tooltip  effect="dark" :content="$t('pc_biz_ote_lbl_h5joindevice')" placement="top">
                  <span class="ml8 v-mid color-gray-9"><yxt-svg class="yxtbiz-exam-arrange__tip-icon" width="16px" height="16px" icon-class="info-cirlce-o" /></span>
                </yxt-tooltip></yxt-checkbox>
                <div class="pl24" v-if="isOnlyMobile">
                  <yxt-checkbox v-model="isOnlyMobileApp" class="" :disabled="status !== 0">{{ $t('pc_biz_ote_lbl_allowexaminapp') }}</yxt-checkbox>
                  <div class="pl24" v-if="isOnlyMobileApp && false">
                    <yxt-checkbox v-model="isEnabledAfr" class="" :disabled="status !== 0">{{ $t('pc_biz_ote_lbl_openface') }}</yxt-checkbox>
                    <span class="ml5">{{ $t('pc_biz_ote_lbl_openfaceshotduration1') }}<span class="mh8">
                        <yxt-input v-model="ruleForm.afrMinCell" v-enter-number ref="afrMinCell" style="width:96px" :disabled="status !== 0"></yxt-input> ~ <yxt-input  v-enter-number ref="afrMaxCell" v-model="ruleForm.afrMaxCell" style="width:96px" :disabled="status !== 0"></yxt-input>
                    </span>{{ $t('pc_biz_ote_lbl_openfaceshotduration2') }}</span>
                  </div>
                </div>
                <div class="pl24" v-if="isOnlyMobile">
                  <yxt-checkbox v-model="isOnlyMobileH5" class="" :disabled="status !== 0">{{ $t('pc_biz_ote_lbl_allowexaminh5web') }}</yxt-checkbox>
                </div>
              </yxt-form-item>
              <yxt-form-item class="color-gray-9" v-if="!oteSwitchScreenStatus.hidden" >
                <yxt-checkbox v-model="isForbidExit" class="" :disabled="status !== 0 || oteSwitchScreenStatus.disabled">{{ $t('pc_biz_ote_lbl_examleavesetting') }}</yxt-checkbox>
                <yxt-input v-if="isForbidExit" maxlength="3" ref="exitTimes" v-model="ruleForm.exitTimes" class="mh8 w70" :disabled="status !== 0 || oteSwitchScreenStatus.disabled" v-enter-number style="width:96px;"></yxt-input>
                <span v-if="isForbidExit" class="">{{ $t('pc_biz_ote_lbl_time') }}</span>
              </yxt-form-item>
              <yxt-form-item v-if="!oteLeaveSubmitStatus.hidden" class="color-gray-9">
                <yxt-checkbox v-model="isMaxLeaveTime" :disabled="status !== 0 || oteLeaveSubmitStatus.disabled">{{ $t('pc_biz_ote_lbl_examleavesettingtimelimit1') }}</yxt-checkbox>
                <yxt-input maxlength="3" ref="maxLeaveTime" v-model="ruleForm.maxLeaveTime" class="mh8 w70" :disabled="status !== 0 || oteLeaveSubmitStatus.disabled" v-enter-number style="width:96px;"></yxt-input><span class="">{{ $t('pc_biz_ote_lbl_examleavesettingtimelimit2') }}</span>
              </yxt-form-item>
              <yxt-form-item class="color-gray-9">
                <yxt-checkbox v-model="isFixedDevice" class="" :disabled="status !== 0">{{ $t('pc_biz_ote_lbl_examcantchangedevice') }}
                <yxt-tooltip  effect="dark" :content="$t('pc_biz_ote_tip_examcantchangedevicetip')" placement="top">
                  <span class="ml8 v-mid color-gray-9"><yxt-svg class="yxtbiz-exam-arrange__tip-icon" width="16px" height="16px" icon-class="info-cirlce-o" /></span>
                </yxt-tooltip></yxt-checkbox>
              </yxt-form-item>
          </yxt-form>
        </div>
      </yxt-col>
    </yxt-row>
  </div>
</template>
<script>
import { enmuFunctions } from '../../../function-points';
import { resetValueBystatus, getFunStatus } from '../../../common-util/factorUtils';
export default {
  name: 'arrangeSetting',
  components: {
  },
  props: {
    id: {
      type: String,
      required: false
    },
    arrange: {
      type: Object,
      default: () => { return {}; }
    },
    functionCode: {
      type: String,
      default: ''
    },
    dataPermissionCodes: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    oteSwitchScreenStatus() {
      return getFunStatus(enmuFunctions.PREVENT_SWITCH_SCREEN_SET);
    },
    oteLeaveSubmitStatus() {
      return getFunStatus(enmuFunctions.COMPULSORY_SUBMISSION_SET);
    }
  },
  data() {
    const validateSubmitTime = (rule, value, callback) => {
      let currentTime = new Date();
      let startTime = null;
      let endTime = null;
      if (this.isForceSubmitCtrl) {
        if (!this.ruleForm.forceSubmitTime) {
          callback(new Error(this.$t('pc_biz_ote_msg_submittimenotnull')));
          return;
        }
        if (this.arrange.entryTimeCtrl) {
          if (!this.arrange.entryStartTime || !this.arrange.entryEndTime) {
            callback();
            return;
          }
          startTime = new Date(this.arrange.entryStartTime.replace(/-/g, '/'));
        }
        endTime = new Date(this.ruleForm.forceSubmitTime.replace(/-/g, '/'));
        if (this.status === 0) {
          if (endTime < currentTime) {
            callback(new Error(this.$t('pc_biz_ote_msg_submittimemustlasternow')));
            return;
          }
        }
        if (endTime <= startTime) {
          callback(new Error(this.$t('pc_biz_ote_msg_submittimemustlasterstarttime')));
          return;
        }
      }
      callback();
    };
    const validateTimesLen = (rule, value, callback) => {
      if (this.isUsedTimesCtrl) {
        if (!this.ruleForm.usedTimesLenMin) {
          callback(new Error(this.$t('pc_biz_ote_msg_examlengthnotnull')));
          return;
        }
        if (parseInt(this.ruleForm.usedTimesLen, 0) === 0) {
          callback(new Error(this.$t('pc_biz_ote_msg_examlengthlimit')));
          return;
        }
      }
      callback();
    };
    const validateRepeatTimes = (rule, value, callback) => {
      if (this.isRepeated) {
        if (!this.ruleForm.repeatTimes && this.ruleForm.repeatTimes !== 0) {
          callback(new Error(this.$t('pc_biz_ote_msg_allowrepeattimenotnull')));
          return;
        }
      }
      callback();
    };
    return {
      isAllowUpload: false,
      isAllowViewResultDetail: false,
      isAllowViewResultDetailAnswer: false,
      isAllowViewResultDetailErrorQues: false,
      isAllowViewResultDetailExplain: false,
      isAllowViewResultDetailStartTime: false,
      isAllowViewResultPassed: true,
      isAnonyMark: false,
      isAutoMarkAnswer: false,
      isAutoMarkFillin: false,
      isEnabledAfr: false,
      isEntryTimeCtrl: false,
      isFixedDevice: false,
      isForbidExit: false,
      isForceSubmitCtrl: false,
      isNoAnswerNoMark: false,
      isOnlyMobile: false,
      isOnlyMobileApp: false,
      isOnlyMobileH5: false,
      isOnlyPc: false,
      isRandomItemSort: false,
      isRandomSort: false,
      isRepeated: false,
      isUsedTimesCtrl: false,
      isViewResult: true,
      isViewResultScore: true,
      isMaxLeaveTime: false,
      isExcludeExamCenter: false,
      isAllowViewResultDetailTime: false, // 是否设置答卷查看时间
      ViewResultDetailTime: [],
      ruleForm: {
        forceSubmitCtrl: 0, // 是否限制强制提交
        forceSubmitTime: '', // 强制提交时间
        usedTimesCtrl: 0, // 是否控制考试用时
        usedTimesLenMin: 0, // 考试允许用时(单位秒)
        viewResult: 1, // 批阅后允许学员查看考试成绩
        viewResultScore: 1, // 是否显示考试分数
        autoMarkAnswer: 0, // 是否自动批阅问答题
        autoMarkFillin: 0, // 是否自动批阅填空题
        anonyMark: 0, // 是否匿名批阅
        noAnswerNoMark: 0, // 主观题未作答不自动批阅
        allowViewResultDetail: 0, // 是否允许批阅后允许学员查看答卷详情
        allowViewResultDetailAnswer: 0, // 是否允许查看答卷详情中的答案
        allowViewResultDetailErrorQues: 0, // 是否仅允许查看答卷详情中的错误试题
        allowViewResultDetailExplain: 0, // 是否允许查看答卷详情中的解析
        allowViewResultDetailStartTime: '', // 开放查看答卷的开始时间
        viewResultDetailEndTime: '', // 开放查看答卷的结束时间
        allowViewResultPassed: 1, // 是否显示通过标签
        randomSort: 0, // 是否打乱答题时的试题顺序
        randomItemSort: 0, // 是否打乱单选、复选题的选项顺序
        onlyPc: 0, // 是否仅允许PC中考试
        onlyMobile: 0, // 是否仅允许移动端考试
        onlyMobileApp: 0, // 是否仅允许APP中考试
        enabledAfr: 0, // 是否开启人脸识别控制
        afrMinCell: 0, // 人脸识别时的抓拍最小间隔秒数
        afrMaxCell: 0, // 人脸识别时的抓拍最大间隔秒数
        onlyMobileH5: 0, // 是否仅允许H5中考试
        excludeExamCenter: 0, // 此安排是否不出现在考试中心
        forbidExit: 0, // 是否禁止中途退出
        exitTimes: 0, // 允许中途退出次数
        fixedDevice: 0, // 是否固定考试设备
        maxLeaveTime: '', // 允许考试中离开的时间(指不操作鼠标、触摸、移动)。(单位秒)
        repeatTimes: 0, // 允许重复考试次数
        repeated: 0, // 是否允许重复考试
        allowUpload: 0 // 是否允许问答题答题时上传附件
      },
      needCheck: 0,
      attendType: 0,
      status: 0,
      rules: {
        forceSubmitTime: [
          { required: false, validator: validateSubmitTime, trigger: 'blur' }
        ],
        usedTimesLenMin: [
          { required: false, validator: validateTimesLen, trigger: 'blur' }
        ],
        repeatTimes: [
          { required: false, validator: validateRepeatTimes, trigger: 'blur' }
        ]
      }
    };
  },
  created() {
    this.ruleFormStr = JSON.stringify(this.ruleForm);
  },
  methods: {
    // 加载考试设置信息
    loadFormData() {
      this.isAllowUpload = this.ruleForm.allowUpload === 1;
      this.isAllowViewResultDetail = this.ruleForm.allowViewResultDetail === 1;
      this.isAllowViewResultDetailAnswer = this.ruleForm.allowViewResultDetailAnswer === 1;
      this.isAllowViewResultDetailErrorQues = this.ruleForm.allowViewResultDetailErrorQues === 1;
      this.isAllowViewResultDetailExplain = this.ruleForm.allowViewResultDetailExplain === 1;
      this.isAllowViewResultDetailStartTime = this.ruleForm.allowViewResultDetailStartTime === 1;
      this.isAllowViewResultPassed = this.ruleForm.allowViewResultPassed === 1;
      this.isAnonyMark = this.ruleForm.anonyMark === 1;
      this.isAutoMarkAnswer = this.ruleForm.autoMarkAnswer === 1;
      this.isAutoMarkFillin = this.ruleForm.autoMarkFillin === 1;
      this.isEnabledAfr = this.ruleForm.enabledAfr === 1;
      this.isFixedDevice = this.ruleForm.fixedDevice === 1;
      this.isForbidExit = this.ruleForm.forbidExit === 1;
      this.isForceSubmitCtrl = this.ruleForm.forceSubmitCtrl === 1;
      this.isNoAnswerNoMark = this.ruleForm.noAnswerNoMark === 1;
      this.isOnlyMobile = this.ruleForm.onlyMobile === 1;
      this.isOnlyMobileApp = this.ruleForm.onlyMobileApp === 1;
      this.isOnlyMobileH5 = this.ruleForm.onlyMobileH5 === 1;
      this.isOnlyPc = this.ruleForm.onlyPc === 1;
      this.isRandomItemSort = this.ruleForm.randomItemSort === 1;
      this.isRandomSort = this.ruleForm.randomSort === 1;
      this.isRepeated = this.ruleForm.repeated === 1;
      this.isUsedTimesCtrl = this.ruleForm.usedTimesCtrl === 1;
      this.isViewResult = this.ruleForm.viewResult === 1;
      this.isViewResultScore = this.ruleForm.viewResultScore === 1;
      this.isMaxLeaveTime = this.ruleForm.maxLeaveTime > 0;
      this.isExcludeExamCenter = this.ruleForm.excludeExamCenter === 1;
      this.isAllowViewResultDetailTime = false;
      if (this.ruleForm.allowViewResultDetailStartTime && this.ruleForm.viewResultDetailEndTime) {
        this.isAllowViewResultDetailTime = true;
      }
      this.ViewResultDetailTime = [];
      if (this.isAllowViewResultDetailTime) {
        this.ViewResultDetailTime = [ this.ruleForm.allowViewResultDetailStartTime, this.ruleForm.viewResultDetailEndTime ];
      }
      // 处理要素功能的状态及属性重置
      if (this.status === 0) {
        this.isEnabledAfr && resetValueBystatus(enmuFunctions.FACE_ENABLE, () => { this.isEnabledAfr = false; });
        this.isForbidExit && resetValueBystatus(enmuFunctions.PREVENT_SWITCH_SCREEN_SET, () => { this.isForbidExit = false; });
        this.isMaxLeaveTime && resetValueBystatus(enmuFunctions.COMPULSORY_SUBMISSION_SET, () => { this.isMaxLeaveTime = false; });
      }
    },
    // 获取考试设置信息
    getFormData() {
      this.ruleForm.allowUpload = this.isAllowUpload ? 1 : 0;
      this.ruleForm.allowViewResultDetail = this.isAllowViewResultDetail ? 1 : 0;
      this.ruleForm.allowViewResultDetailAnswer = this.isAllowViewResultDetailAnswer ? 1 : 0;
      this.ruleForm.allowViewResultDetailErrorQues = this.isAllowViewResultDetailErrorQues ? 1 : 0;
      this.ruleForm.allowViewResultDetailExplain = this.isAllowViewResultDetailExplain ? 1 : 0;
      this.ruleForm.allowViewResultDetailStartTime = this.isAllowViewResultDetailStartTime ? 1 : 0;
      this.ruleForm.allowViewResultPassed = this.isAllowViewResultPassed ? 1 : 0;
      this.ruleForm.anonyMark = this.isAnonyMark ? 1 : 0;
      this.ruleForm.autoMarkAnswer = this.isAutoMarkAnswer ? 1 : 0;
      this.ruleForm.autoMarkFillin = this.isAutoMarkFillin ? 1 : 0;
      this.ruleForm.enabledAfr = this.isEnabledAfr ? 1 : 0;
      if (!this.isEnabledAfr) {
        this.ruleForm.afrMaxCell = 0;
        this.ruleForm.afrMinCell = 0;
      }
      this.ruleForm.fixedDevice = this.isFixedDevice ? 1 : 0;
      this.ruleForm.forbidExit = this.isForbidExit ? 1 : 0;
      if (!this.isForbidExit) {
        this.ruleForm.exitTimes = 0;
      }
      this.ruleForm.forceSubmitCtrl = this.isForceSubmitCtrl ? 1 : 0;
      this.ruleForm.noAnswerNoMark = this.isNoAnswerNoMark ? 1 : 0;
      this.ruleForm.onlyMobile = this.isOnlyMobile ? 1 : 0;
      this.ruleForm.onlyMobileApp = this.isOnlyMobileApp ? 1 : 0;
      this.ruleForm.onlyMobileH5 = this.isOnlyMobileH5 ? 1 : 0;
      this.ruleForm.onlyPc = this.isOnlyPc ? 1 : 0;
      this.ruleForm.randomItemSort = this.isRandomItemSort ? 1 : 0;
      this.ruleForm.randomSort = this.isRandomSort ? 1 : 0;
      this.ruleForm.repeated = this.isRepeated ? 1 : 0;
      if (!this.isRepeated) {
        this.ruleForm.repeatTimes = 0;
      }
      this.ruleForm.usedTimesCtrl = this.isUsedTimesCtrl ? 1 : 0;
      if (!this.isUsedTimesCtrl) {
        this.ruleForm.usedTimesLenMin = 0;
      }
      this.ruleForm.viewResult = this.isViewResult ? 1 : 0;
      this.ruleForm.viewResultScore = this.isViewResultScore ? 1 : 0;
      this.ruleForm.excludeExamCenter = this.isExcludeExamCenter ? 1 : 0;
      this.ruleForm.allowViewResultDetailStartTime = '';
      this.ruleForm.viewResultDetailEndTime = '';
      if (this.isAllowViewResultDetailTime) {
        this.ruleForm.allowViewResultDetailStartTime = this.ViewResultDetailTime[0];
        this.ruleForm.viewResultDetailEndTime = this.ViewResultDetailTime[1];
      }
      if (!this.isMaxLeaveTime) {
        // this.ruleForm.maxLeaveTime = 0;
      }

      this.ruleForm.usedTimesLenMin = parseInt(this.ruleForm.usedTimesLenMin, 0);
      this.ruleForm.repeatTimes = parseInt(this.ruleForm.repeatTimes, 0);
      this.ruleForm.exitTimes = parseInt(this.ruleForm.exitTimes, 0);
      this.ruleForm.afrMinCell = parseInt(this.ruleForm.afrMinCell, 0);
      this.ruleForm.afrMaxCell = parseInt(this.ruleForm.afrMaxCell, 0);
    },
    checkFormData() {
      let currentTime = new Date();
      let startTime = null;
      let endTime = null;
      let isPass = false;
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          isPass = true;
        } else {
          this.$message({
            type: 'error',
            message: this.$t('pc_biz_ote_msg_checkinput')
          });
        }
      });
      if (!isPass) {
        return false;
      }
      if (this.isAllowViewResultDetailTime) {
        if (!this.ViewResultDetailTime || this.ViewResultDetailTime.length < 2) {
          this.$message({
            type: 'warning',
            message: this.$t('pc_biz_ote_msg_viewanswertimenotnull')
          });
          return false;
        }
        startTime = new Date(this.ViewResultDetailTime[0].replace(/-/g, '/'));
        endTime = new Date(this.ViewResultDetailTime[1].replace(/-/g, '/'));
        if (startTime < currentTime) {
          this.$message({
            type: 'warning',
            message: this.$t('pc_biz_ote_msg_viewanswertimemustlasternow')
          });
          return false;
        }
        if (startTime > endTime) {
          this.$message({
            type: 'warning',
            message: this.$t('pc_biz_ote_msg_viewanswertimemustlasterstarttime')
          });
          return false;
        }
      }
      if (this.isEnabledAfr) {
        if (this.ruleForm.afrMinCell === '') {
          this.$message({
            type: 'warning',
            message: this.$t('pc_biz_ote_msg_facecheckrangestartnotnull')
          });
          this.$refs.afrMinCell.$el.querySelector('input').focus();
          return false;
        }
        if (parseInt(this.ruleForm.afrMinCell, 0) <= 0) {
          this.$message({
            type: 'warning',
            message: this.$t('pc_biz_ote_msg_facecheckrangestartlimit')
          });
          this.$refs.afrMinCell.$el.querySelector('input').focus();
          return false;
        }
        if (this.ruleForm.afrMaxCell === '') {
          this.$message({
            type: 'warning',
            message: this.$t('pc_biz_ote_msg_facecheckrangeendnotnull')
          });
          this.$refs.afrMaxCell.$el.querySelector('input').focus();
          return false;
        }
        if (parseInt(this.ruleForm.afrMaxCell, 0) < parseInt(this.ruleForm.afrMinCell, 0)) {
          this.$message({
            type: 'warning',
            message: this.$t('pc_biz_ote_msg_facecheckrangeendlimit')
          });
          this.$refs.afrMaxCell.$el.querySelector('input').focus();
          return false;
        }
      }
      if (this.isForbidExit) {
        if (this.ruleForm.exitTimes === '' || window.isNaN(this.ruleForm.exitTimes)) {
          this.$message({
            type: 'warning',
            message: this.$t('pc_biz_ote_msg_examleavesettingnotnull')
          });
          this.ruleForm.exitTimes = '';
          this.$refs.exitTimes.$el.querySelector('input').focus();
          return false;
        }
        if (parseInt(this.ruleForm.exitTimes, 0) <= 0) {
          this.$message({
            type: 'warning',
            message: this.$t('pc_biz_ote_msg_examleavesettinglimit')
          });
          this.$refs.exitTimes.$el.querySelector('input').focus();
          return false;
        }
      }
      if (this.isMaxLeaveTime) {
        if (this.ruleForm.maxLeaveTime === '') {
          this.$message({
            type: 'warning',
            message: this.$t('pc_biz_ote_msg_examnooperatetimenotnull')
          });
          this.$refs.maxLeaveTime.$el.querySelector('input').focus();
          return false;
        }
        if (parseInt(this.ruleForm.maxLeaveTime, 0) <= 0) {
          this.$message({
            type: 'warning',
            message: this.$t('pc_biz_ote_msg_examnooperatetimelimit')
          });
          this.$refs.maxLeaveTime.$el.querySelector('input').focus();
          return false;
        }
      }
      return true;
    },
    submitForm(type, isSave) {
      this.getFormData();
      if (!this.checkFormData()) {
        return;
      }
      if (isSave) {
        return this.ruleForm;
      } else {
        this.$emit('next');
      }
    },
    handleError(error) {
      error = error.error;
      let msg = error.message;
      this.$message({
        message: msg,
        type: 'error'
      });
    },
    checkChange() {
      this.getFormData();
      let ruleFormStrNew = JSON.stringify(this.ruleForm);
      return this.ruleFormStr !== ruleFormStrNew;
    }
  },
  watch: {
    arrange(res) {
      this.attendType = res.attendType;
      this.needCheck = res.needCheck;
      this.status = res.status;
      for (let key in this.ruleForm) {
        if (res.hasOwnProperty(key)) {
          this.ruleForm[key] = res[key];
        }
      }
      this.loadFormData();
      this.getFormData();
      this.ruleFormStr = JSON.stringify(this.ruleForm);
    },
    isAllowViewResultDetail: function(val) {
      if (!val) {
        this.isAllowViewResultDetailAnswer = false;
        this.isAllowViewResultDetailErrorQues = false;
        this.isAllowViewResultDetailExplain = false;
        this.isAllowViewResultDetailTime = false;
        this.isAllowViewResultDetailStartTime = '';
        this.ViewResultDetailTime = [];
      }
    },
    isOnlyMobile: function(val) {
      if (val) {
        this.isOnlyPc = false;
      } else {
        this.isOnlyMobileApp = false;
        this.isOnlyMobileH5 = false;
      }
    },
    isOnlyMobileApp: function(val) {
      if (val) {
        this.isOnlyMobileH5 = false;
      } else {
        this.isEnabledAfr = false;
        this.ruleForm.afrMinCell = 0;
        this.ruleForm.afrMaxCell = 0;
      }
    },
    isOnlyMobileH5: function(val) {
      if (val) {
        this.isOnlyMobileApp = false;
      }
    },
    isOnlyPc: function(val) {
      if (val) {
        this.isOnlyMobile = false;
      }
    },
    isMaxLeaveTime: function(val) {
      if (val) {
        if (!this.ruleForm.maxLeaveTime) {
          this.ruleForm.maxLeaveTime = 3;
        }
      } else {
        this.ruleForm.maxLeaveTime = '';
      }
    },
    isForbidExit: function(newVal) {
      if (newVal) {
        if (this.ruleForm.exitTimes === 0) {
          this.ruleForm.exitTimes = 1;
        }
      } else {
        this.ruleForm.exitTimes = 0;
      }
    }
  },
  directives: {
    'enter-number': el => {
      el.onkeyup = () => {
        if (el.nodeName === 'INPUT' && el.type === 'text') {
          if (el.value) {
            el.value = el.value.replace(/[^\d]/g, '');
          }
        } else {
          if (document.activeElement.nodeName === 'INPUT' && document.activeElement.type === 'text') {
            let val = document.activeElement.value;
            if (val) {
              document.activeElement.value = val.replace(/[^\d]/g, '');
            }
          }
        }
      };
    },
    'enter-float': el => {
      el.onkeyup = () => {
        if (el.nodeName === 'INPUT' && el.type === 'text') {
          let val = el.value;
          let reg = new RegExp('^[\\d]*\\.?\\d{0,1}$');
          if (val && !reg.test(val)) {
            if (el.attributes['data_val']) {
              val = el.attributes['data_val'].nodeValue;
            } else {
              val = '';
            }
          }
          el.value = val;
          el.setAttribute('data_val', val);
        } else {
          if (document.activeElement.nodeName === 'INPUT' && document.activeElement.type === 'text') {
            let val = document.activeElement.value;
            let reg = new RegExp('^[\\d]*\\.?\\d{0,1}$');
            if (val && !reg.test(val)) {
              if (document.activeElement.attributes['data_val']) {
                val = document.activeElement.attributes['data_val'].nodeValue;
              } else {
                val = '';
              }
            }
            document.activeElement.value = val;
            document.activeElement.setAttribute('data_val', val);
          }
        }
      };
    }
  }
};
</script>
